// /ReferralAdmin/Rewards satırındaki `fraudflags` alanı JSON string dizi
// ("[\"same_owner_phone\"]"), null veya zaten bir dizi olabilir. Güvenli parse.
export const parseFraudFlags = (raw) => {
  if (Array.isArray(raw)) {
    return raw.filter((f) => typeof f === 'string' && f.length > 0);
  }
  if (typeof raw !== 'string' || !raw.trim()) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((f) => typeof f === 'string' && f.length > 0)
      : [];
  } catch {
    return [];
  }
};

// "same_owner_phone" -> "Same owner phone"
export const formatFraudFlag = (flag) => {
  if (typeof flag !== 'string' || !flag) return '';
  const spaced = flag.replace(/[_-]+/g, ' ').trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};
